module.exports = __webpack_public_path__ + "static/media/play.3ff4a57f.png";